export default __webpack_public_path__ + "static/media/login_successful.08fbe5bb.gif";